// extracted by mini-css-extract-plugin
export var formContainer = "_ib-0";
export var message = "_ib-1";